import { Component } from '@angular/core';
import { CONTACT } from './config';
import { ApiService } from './api.service';
import { ViewportScroller } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    
})
export class AppComponent {
  title = 'gouri-gold';
  

 values={'mobile':'12345567890','landline':'0154-19953','email':'gauri@gmail','address':'patna','facebook':'FB.com','instagram':'insta.com'};
  data: any;
  constructor(private api:ApiService)
  {

      this.api.Get(CONTACT).then(data=>{
        this.values=data['data'];
      }).catch(d=>{
        console.log(d);
      })
       
this.api.getlogin.subscribe(data=>{
  //console.log("app"+data);
  if(data==1)
  {
    this.data == data;
    this.api.updateWishlist();
    this.api.updateCart();
  }
})
  }
  changeOfRoutes(){
    console.log('routchanged');
    this.api.updateCart();
  }
}

